export function animateCounters(): void {
  const counters = document.querySelectorAll<HTMLElement>('[data-value]')
  const speed = 300

  const animateCounter = (counter: HTMLElement): void => {
    const value = +counter.getAttribute('data-value')
    const data = +counter.innerText

    if (data >= value) {
      counter.innerText = value.toString()
      return
    }
    const time = value / speed
    counter.innerText = Math.ceil(data + time).toString()
    setTimeout(() => animateCounter(counter), 1)
  }

  init()

  function init(): void {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateCounter(entry.target as HTMLElement)
              observer.unobserve(entry.target)
            }
          })
        },
        { rootMargin: '0px 0px 0px 0px' },
      )
      counters.forEach(($singleCounter) => observer.observe($singleCounter))
    } else {
      counters.forEach(($singleCounter) => animateCounter($singleCounter))
    }
  }
}
